// Εισαγγελίες accepted by /poinpin (same values and labels as Poiniko.jsx).
export const EISAGGELIES = [
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΕΦΕΤΩΝ ΑΘΗΝΩΝ", label: "ΕΙΣ.ΕΦ.ΑΘΗΝΩΝ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΕΦΕΤΩΝ ΕΥΒΟΙΑΣ", label: "ΕΙΣ.ΕΦ.ΕΥΒΟΙΑΣ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΕΦΕΤΩΝ ΘΕΣΣΑΛΟΝΙΚΗΣ", label: "ΕΙΣ.ΕΦ.ΘΕΣΣΑΛΟΝΙΚΗΣ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΕΦΕΤΩΝ ΠΕΙΡΑΙΑ", label: "ΕΙΣ.ΕΦ.ΠΕΙΡΑΙΑ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΠΡΩΤΟΔΙΚΩΝ ΑΘΗΝΩΝ", label: "ΕΙΣ.ΠΡ.ΑΘΗΝΩΝ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΠΡΩΤΟΔΙΚΩΝ ΘΕΣΣΑΛΟΝΙΚΗΣ", label: "ΕΙΣ.ΠΡ.ΘΕΣΣΑΛΟΝΙΚΗΣ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΠΡΩΤΟΔΙΚΩΝ ΠΕΙΡΑΙΑ", label: "ΕΙΣ.ΠΡ.ΠΕΙΡΑΙΑ" },
  { value: "ΕΙΣΑΓΓΕΛΙΑ ΠΡΩΤΟΔΙΚΩΝ ΧΑΛΚΙΔΑΣ", label: "ΕΙΣ.ΠΡ.ΧΑΛΚΙΔΑΣ" },
];

const LABELS = Object.fromEntries(EISAGGELIES.map((e) => [e.value, e.label]));

// Short label for a stored eisag value; unknown values are shown as is.
export const eisagLabel = (value) => LABELS[value] ?? value ?? "";
